import { Horaire } from '@/model/horaire';
import { Message } from '@/model/message';

import Axios from 'axios';
import { ApiUtils } from './api-utils';

export class ReferentielApi {
  static getHoraires (): Promise<Horaire[]> {
    return ApiUtils.responseParser(Axios.get('/web/v1/horaires'), [Horaire]);
  }

  static getInformationsMarche (): Promise<Message> {
    return ApiUtils.responseParser(Axios.get('/web/v1/informations-marche/ACTIVE'), Message);
  }
}
